/**
 * Authorization HOC for pages that need logged in user.
 * - Wrap page component with "withAuth" to apply login check to it.
 */
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import defaultTheme from 'themes/default';

import Loader from '../Loader/Loader';
import Login from '../Login/Login';

type Props = {
  isLoggedIn: boolean;
  isLoading: boolean;
  isLoginLoading: boolean;
};

const mapStateToProps = ({ userData }) => ({
  isLoggedIn: userData?.user?.isLoggedIn,
  isLoginLoading: userData?.isLoading,
});

// TODO: React.FC<any> is a temp fix for linter to pass, we should actually start using hook instead of HOC.
const withAuth = (Component): React.FC<any> => {
  const Auth = (props: Props) => {
    const { isLoggedIn, isLoading, isLoginLoading } = props;

    // Show loader while checking user login or while loading route change or is SSR.
    // We won't render Component while SSR because login check happens client side anyway.
    if (isLoading || isLoginLoading || typeof window === 'undefined') {
      return (
        // Specify style here for server side to be able to show spinner correctly
        <Loader
          size={40}
          spinnerStyle={{
            color: defaultTheme.palette.primary.main,
          }}
        />
      );
    }

    // If user is not logged in, return login component
    if (!isLoggedIn) {
      return <Login className="mt-4" type="page" />;
    }

    // If user is logged in, return original component
    return <Component {...props} />;
  };

  // Copy getInitial props so it will run as well
  if (Component.getInitialProps) {
    Auth.getInitialProps = Component.getInitialProps;
  }

  return Auth;
};

export default compose(connect(mapStateToProps), withAuth);
